import { Suspense, memo } from 'react';
import { Skeleton, SkeletonProps } from 'antd';
import ErrorBoundary from 'components/ErrorBoundary';
import { lazyImport, type LazySvgProps } from './utils';

/* Icon skeleton component */
function IconSkeleton(props: SkeletonProps) {
  return <Skeleton.Avatar size='large' shape='circle' {...props} />;
}
export const MemoizedIconSkeleton = memo(IconSkeleton);

function LazySvg({
  name,
  subFolder,
  qaSelector,
  fallback = <MemoizedIconSkeleton active />,
  ...rest
}: LazySvgProps) {
  const LazyIcon = lazyImport({ name, subFolder });

  return (
    <ErrorBoundary fallback={fallback}>
      <Suspense fallback={fallback}>
        <LazyIcon data-qa-selector={qaSelector} {...rest} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default memo(LazySvg);
